BX.Sotbit.B2C.classes.MobileMenu = class {
    isOpen = false;
    container = null;
    currentItemId = 0;
    currentDepth = 0;
    data = {};
    catalogLink = null;

    chevronIcon = `
        <svg width="16" viewBox="0 0 16 16">
            <use xlink:href="${BX.Sotbit.B2C.templatePath}/assets/image/sprite.svg#chevron"></use>
        </svg>`;

    constructor(header) {
        this.header = header;
        this.container = document.querySelector('[data-entity="header-mobile-menu"]');

        this.prepareData();
    }

    prepareData() {
        if (BX.Sotbit.B2C.layout.topMenuData) {
            this.data.top = BX.Sotbit.B2C.layout.topMenuData;
        }

        if (this.header.catalogMenu) {
            this.data.catalog = this.header.catalogMenu.data.filter((item) => item.LINK);

            this.catalogLink = `/${this.data.catalog[0].LINK.split('/')[1]}/`;
        }

        if (BX.Sotbit.B2C.layout.secondMenu) {
            this.data.second = BX.Sotbit.B2C.layout.secondMenu.data;
        }
    }

    adjustPosition() {
        const headerHeight = this.header.container.clientHeight;

        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    open() {
        BX.Sotbit.B2C.fixBodyScroll();
        this.showStartMenu();
        this.adjustPosition();
        BX.Sotbit.B2C.showElement(this.container);
    }

    close() {
        BX.Sotbit.B2C.unfixBodyScroll();
        this.clearMenu();
        BX.Sotbit.B2C.hideElement(this.container);
    }

    showStartMenu() {
        this.clearMenu();

        ['catalog', 'top', 'second'].forEach((sectionCode) => {
            if (!this.data.hasOwnProperty(sectionCode)) {
                return;
            }

            if (sectionCode === 'catalog') {
                this.container.appendChild(this.createCatalogFirstItem());
            } else {
                this.container.appendChild(this.createStartMenuSection(sectionCode));
            }
        });
    }

    showCatalogSubmenu() {
        this.clearMenu();
        const items = this.data['catalog'].filter((item) => +item.DEPTH_LEVEL === 1);
        const menuOptions = {
            props: {
                className: 'header-mobile-menu-section m-0 mh-100',
            },
            children: [
                BX.create('a', {
                    props: {
                        className: 'd-flex gap-4 p-4 fw-medium align-items-center',
                        href: this.catalogLink
                    },
                    children: [
                        BX.create('div', {
                            children: this.chevronIcon,
                            events: {
                                click: (e) => {
                                    e.preventDefault();
                                    this.showStartMenu();
                                }
                            }
                        }),
                        BX.create('span', {
                            text: BX.message('CATALOG')
                        })
                    ],
                }),
                ...items.map(item => this.createItem('catalog', item))
            ],
        }

        this.container.appendChild(BX.create('ul', menuOptions));
    }

    showSubmenuLevel(sectionCode, parentItemId, depthLevel) {
        this.clearMenu();

        const items = this.data[sectionCode].filter((item) => +item.DEPTH_LEVEL === depthLevel + 1 && +item.PARENT_INDEX === parentItemId);
        const menuOptions = {
            props: {
                className: 'header-mobile-menu-section m-0 mh-100',
            },
            children: [
                this.createSectionHeader(sectionCode, this.data[sectionCode].find((item) => +item.ITEM_INDEX === parentItemId && +item.DEPTH_LEVEL === depthLevel)),
                ...items.map(item => this.createItem(sectionCode, item))
            ],
        }

        this.container.appendChild(BX.create('ul', menuOptions));
    }

    clearMenu() {
        while (this.container.firstChild) {
            this.container.removeChild(this.container.firstChild);
        }
    }

    createStartMenuSection(sectionCode) {
        if (!BX.Type.isArray(this.data[sectionCode])) {
            this.data[sectionCode] = Object.values(this.data[sectionCode]);
        }

        const firstLevelItems = this.data[sectionCode].filter((item) => +item.DEPTH_LEVEL === 1);

        return BX.create('ul', {
            props: {
                className: 'header-mobile-menu-section m-0 mh-100',
            },
            children: firstLevelItems.map(item => this.createItem(sectionCode, item))
        });
    }

    createCatalogFirstItem() {
        return BX.create('a', {
            props: {
                className: 'header-mobile-menu-catalog icon-reverse d-flex justify-content-between align-items-center gap-4 p-4 fw-medium text-dark',
                href: this.catalogLink
            },
            children: [
                BX.create('span', {
                    text: BX.message('CATALOG')
                }),
                BX.create('div', {
                    html: this.chevronIcon
                })
            ],
            events: {
                click: (e) => {
                    e.preventDefault();
                    this.showCatalogSubmenu();
                }
            }
        });
    }

    createItem(sectionCode, item) {
        return BX.create('li', {
            props: {
                className: `m-0 fs-1${sectionCode === 'top' ? ' text-secondary-700' : ''}`,
            },
            children: [
                BX.create('a', {
                    props: {
                        className: 'd-flex justify-content-between p-4 text-dark icon-reverse',
                        href: item.LINK
                    },
                    children: [
                        BX.create('span', {
                            text: item.TEXT
                        }),
                        item.IS_PARENT && BX.create('div', {
                            html: this.chevronIcon
                        })
                    ],
                    events: {
                        click: (e) => {
                            if (item.IS_PARENT) {
                                e.preventDefault();
                                this.showSubmenuLevel(sectionCode, +item.ITEM_INDEX, +item.DEPTH_LEVEL)
                            }
                        }
                    }
                })
            ]
        })
    }

    createSectionHeader(sectionCode, item) {
        return BX.create('li', {
            props: {
                className: 'd-flex gap-4 p-4 fw-medium align-items-center'
            },
            children: [
                BX.create('div', {
                    html: this.chevronIcon,
                    events: {
                        click: () => {
                            if (sectionCode === 'catalog' && +item.DEPTH_LEVEL === 1) {
                                this.showCatalogSubmenu();
                            } else {
                                +item.DEPTH_LEVEL > 1
                                    ? this.showSubmenuLevel(sectionCode, +item.PARENT_INDEX, +item.DEPTH_LEVEL - 1)
                                    : this.showStartMenu()
                            }
                        }
                    }
                }),
                BX.create('a', {
                    props: {
                        className: 'fw-medium text-dark',
                        href: item.LINK
                    },
                    text: item.TEXT,
                }),
            ]
        });
    }
}

BX.Sotbit.B2C.classes.Header = class {
    isMobileMenuInitialized = false;
    /** @var BX.Sotbit.B2C.classes.HeaderCatalogMenu */
    catalogMenu = null;
    openMenuButton = null;

    constructor() {
        this.container = document.querySelector('.header');

        if (!this.container) {
            return;
        }

        this.openMenuButton = this.container.querySelector('[data-entity="header-menu-open-btn"]')
        this.topMenu = this.container.querySelector('.header__top');
        this.mainMenu = this.container.querySelector('.header__main');
        this.secondMenu = this.container.querySelector('.header-menu-second');

        this.updateHeaderFixedState();
        this.initializeMobileMenu();
        this.addEventListeners();
    }

    initializeMobileMenu() {
        this.mobileMenu = new BX.Sotbit.B2C.classes.MobileMenu(this);
    }

    openMainMenu() {
        if (!this.mobileMenu.isOpen) {
            if (!this.isMobileMenuInitialized) {
                this.initializeMobileMenu();
            }

            this.mobileMenu.open();
        }

        this.openMenuButton.classList.add('active');
        this.mobileMenu.isOpen = true;
    }

    closeMainMenu() {
        if (this.mobileMenu.isOpen) {
            this.mobileMenu.close();
        }

        this.openMenuButton.classList.remove('active');
        this.mobileMenu.isOpen = false;
    }

    openCatalogMenu() {
        if (!this.catalogMenu) {
            this.catalogMenu = BX.Sotbit.B2C.layout.catalogMenu;
        }

        if (!this.catalogMenu.isOpen) {
            this.catalogMenu.open();
        }

        this.catalogMenu.isOpen = true;
    }

    closeCatalogMenu() {
        if (!this.catalogMenu) {
            this.catalogMenu = BX.Sotbit.B2C.layout.catalogMenu;
        }

        if (this.catalogMenu.isOpen) {
            this.catalogMenu.close();
        }

        this.catalogMenu.isOpen = false;
    }

    toggleMainMenu() {
        this.mobileMenu.isOpen ? this.closeMainMenu() : this.openMainMenu();
    }

    toggleCatalogMenu() {
        if (!this.catalogMenu) {
            this.catalogMenu = BX.Sotbit.B2C.layout.catalogMenu;
        }

        this.catalogMenu.isOpen ? this.closeCatalogMenu() : this.openCatalogMenu();
    }

    updateHeaderFixedState() {
        // if (BX.Sotbit.B2C.isMobile()) {
        //     if (scrollY > 0) {
        //         this.mainMenu.classList.add('hidden');
        //     } else {
        //         this.mainMenu.classList.remove('hidden');
        //     }
        // } else {
            if (scrollY > this.topMenu.offsetHeight) {
                this.container.classList.add('fixed');
                this.container.style.top = `-${this.topMenu.offsetHeight}px`;
                this.secondMenu && this.secondMenu.classList.add('hidden');
            } else {
                this.container.classList.remove('fixed');
                this.container.style.top = '';
                this.secondMenu && this.secondMenu.classList.remove('hidden');
            }
        // }
    }

    addEventListeners() {
        window.addEventListener('scroll', () => this.updateHeaderFixedState(), {passive: true});

        this.openMenuButton.addEventListener('click', () => {
            BX.Sotbit.B2C.isLaptop() ? this.toggleMainMenu() : this.toggleCatalogMenu();
        });

        window.addEventListener('resize', () => {
            this.closeMainMenu();
        });
    }
}

// contacts form in header
BX.Sotbit.B2C.classes.Contacts = class {
    constructor() {
        this.container = document.querySelector('.header .contacts');
        this.header = this.container.querySelector('.contacts-header');
        this.popup = this.container.querySelector('.contacts-popup');
        this.sweetAlertInstance = null;
        this.sweetAlertResult = null;
        this.mixinSwal = null;
        this.isPopupShown = false;

        this.addEventListeners();
    }

    async showPopup() {
        if (this.isPopupShown) {
            return;
        }

        if (BX.Sotbit.B2C.isLaptop()) {
            [this.sweetAlertResult, this.sweetAlertInstance] = await BX.Sotbit.B2C.showPopup({
                title: BX.message('CONTACTS'),
                html: BX.create('div', {
                    html: this.popup.innerHTML
                }),
                width: '100%',
                showCancelButton: false,
                position: 'bottom-end',
                backdrop: true,
                showClass: {
                    popup: `
                          animate__animated
                          animate__fadeInUp
                          animate__faster
                        `
                },
                hideClass: {
                    popup: `
                          animate__animated
                          animate__fadeOutDown
                          animate__faster
                        `
                },
                customClass: {
                    container: 'contacts-swal-container',
                    confirmButton: 'btn d-flex w-100 justify-content-center align-items-center gap-3'
                },
                confirmButtonText: `
                    <svg class="flex-shrink-0" width="24" viewBox="0 0 24 24">
                        <use xlink:href="${BX.Sotbit.B2C.templatePath}/assets/image/sprite.svg#phone"></use>
                    </svg>
                    <span>${BX.message('CONTACTS_BUTTON_TEXT')}</span>
                `
            });

            this.sweetAlertResult.then(result => {
                if (result.isConfirmed) {
                    BX.Sotbit.B2C.showForm('SOTBIT_REQUEST_A_CALL', {
                        MESSAGES: {
                            SUCCESS: BX.message('FORM_SUCCESS')
                        }
                    });
                }

                this.hidePopup();
            });
        } else {
            BX.Sotbit.B2C.showElement(this.popup);
        }

        this.isPopupShown = true;
    }

    hidePopup() {
        if (!this.isPopupShown) {
            return;
        }

        if (BX.Sotbit.B2C.isLaptop()) {
            this.sweetAlertInstance && this.sweetAlertInstance.close();
            delete this.sweetAlertInstance;
        } else {
            BX.Sotbit.B2C.hideElement(this.popup);
        }

        this.isPopupShown = false;
    }

    addEventListeners() {
        this.header.addEventListener('click', () => {
            if (BX.Sotbit.B2C.isLaptop()) {
                this.isPopupShown ? this.hidePopup() : this.showPopup();
            }
        });

        this.header.addEventListener('mouseenter', () => {
            if (!BX.Sotbit.B2C.isLaptop()) {
                this.showPopup();
            }
        });

        this.container.addEventListener('mouseleave', () => {
            if (!BX.Sotbit.B2C.isLaptop()) {
                this.hidePopup()
            }
        });

        window.addEventListener('resize', () => {
           if (!BX.Sotbit.B2C.isLaptop())  {
               this.sweetAlertInstance && this.sweetAlertInstance.close();
               delete this.sweetAlertInstance;
           }
        });
    }
}

BX.ready(function(){
    BX.Sotbit.B2C.classes.Header && (BX.Sotbit.B2C.layout.header = new BX.Sotbit.B2C.classes.Header());
});
